<template>
    <div class="mt-4 mb-2">
        <v-list>
            <div v-for="(action, index) in details">
                <v-list-tile
                    v-bind:class="{ 'action-tile': action.description }"
                >
                    <v-list-tile-content class="width-250">
                        <v-list-tile-title>{{ action.date }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-list-tile-title class="text-xs-right"
                            >{{ action.title }}
                        </v-list-tile-title>
                        <div class="text--disabled text-xs-right width-250">
                            {{ action.description }}
                        </div>
                    </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="index + 1 < details.length"></v-divider>
            </div>
        </v-list>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            details: [],

            callActionsMap: new Map([
                ["LOOKUP_PHONE", "Lookup callerID"],
                ["VALIDATE_PHONE", "Validate Phone"],
                ["VALIDATE_PIN", "Validate Pin / Load Account"],
                ["RECOVER_PIN", "Recover Pin"],
                ["VALIDATE_CARD", "Entered Credit Card"],
                ["VALIDATE_SAVED_CARD", "Validate Saved Card"],
                ["VALIDATE_EXP", "Validate Expiration Date"],
                ["PLAY_MISSING_IMMUNIZATIONS", "Play Missing Immunizations"],
                ["PLAY_REGISTRATION_STATUS", "Play Registration Status"],
                ["TUITION_BALANCE_DETAILS", "Play Tuition Balance Details"],
                [
                    "TRANSPORTATION_BALANCE_DETAILS",
                    "Play Transportation Balance Details",
                ],
                ["PLAY_SAVED_CARDS", "Play Saved Cards List"],
                ["PAYMENT_PLAN_DETAILS", "Play Payment Plan Details"],
                ["START_PAYMENT_PROCESS", "Start Payment Process"],
                ["START_AUTOPAYSETUP_PROCESS", "Start Auto Pay Setup Process"],
                ["PAYMENT_PROCESSING", "Payment Procssing"],
                ["CARD_PROCESSED_SUCCESS", "Payment Processed Successfully"],
                ["CARD_PROCESSED_FAILED", "Payment Failed"],
                ["AUTOPAY_SETUP_FAILED", "Auto Pay Setup Failed"],
                ["AUTOPAY_SETUP_SUCCESS", "Auto Pay Setup Successfull"],
                ["CONTACT_US", "Contact Us"],
                ["HANGUP", "Hangup"],
            ]),
        };
    },
    async created() {
        await this.loadDetails();
    },
    computed: {},
    methods: {
        async loadDetails() {
            const details = await this.$http.get(
                "api/broadcast/getCallActivity?callUUID=" + this.row.callUUID
            );

            this.details = details.map((action) => {
                action.date = moment(action.date).format("LTS");
                action.title =
                    this.callActionsMap.get(action.eventType) ||
                    action.eventType;
                action.description = this.getActionDescription(action);

                return action;
            });
        },
        getActionDescription(action) {
            if (
                [
                    "START_PAYMENT_PROCESS",
                    "START_AUTOPAYSETUP_PROCESS",
                ].includes(action.eventType)
            )
                return null;

            if (action.eventType == "LOAD_SCREENING_INFO") {
                const data = JSON.parse(action.response);

                action.response =
                    "Answered Today: " +
                    (data.hasAllAnswersToday == "1" ? "Yes" : "No") +
                    " | Previous Answers: " +
                    (data.answeredYesterday ? data.answeredYesterday : "No");
            }

            const inputActions = [
                "LOOKUP_PHONE",
                "VALIDATE_PHONE",
                "VALIDATE_PIN",
                "VALIDATE_CARD",
                "VALIDATE_EXP",
                "VALIDATE_SAVED_CARD",
            ];

            if (inputActions.includes(action.eventType)) {
                return action.inputDigits + " | " + action.response;
            }

            if (
                ["ANSWER1", "ANSWER2", "ANSWER3", "ANSWER4"].includes(
                    action.eventType
                )
            ) {
                return action.response + " | Input: " + action.inputDigits;
            }

            if (action.eventType == "CARD_PROCESSED_SUCCESS") {
                const pecies = action.response.split("|");
                const status = pecies
                    .find((p) => p.startsWith("status"))
                    .substring(7);
                const amount = pecies
                    .find((p) => p.startsWith("amount"))
                    .substring(7);

                return "$" + amount + " | " + status;
            }

            return action.response;
        },
    },
};
</script>
<style>
.dinner-ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
.action-tile .v-list__tile {
    height: 65px;
    white-space: normal !important;
}
</style>
